import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { ChangeLanguageComponent } from "../../components";
import { GrannyComponent } from "./components/granny/granny.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";

@NgModule({
	imports: [CommonModule, RouterModule],
	declarations: [NotFoundComponent, GrannyComponent, ChangeLanguageComponent],
	exports: [NotFoundComponent, GrannyComponent, ChangeLanguageComponent],
})
export class NotFoundModule {}
